import * as PAGE_NAME from "../constants/pageName";

const COMMON_POSSIBLE_CONFIG = {
  tenken: [
    PAGE_NAME.DASHBOARD_PAGE,
    PAGE_NAME.CHANGE_PASSWORD_PAGE,
    PAGE_NAME.SETTING_PAGE,
    PAGE_NAME.MY_PAGE_PAGE,
    PAGE_NAME.MACHINE_INPUT_PAGE,
    PAGE_NAME.REGISTER_INSPECTION_PAGE,
    PAGE_NAME.UPDATE_INSPECTION_PAGE,
    PAGE_NAME.JUDGMENT_PAGE,
    PAGE_NAME.UNFINISHED_ACTION_LIST_PAGE,
    PAGE_NAME.TREATMENT_PAGE,
    PAGE_NAME.INSPECTION_STATUS_PAGE,
    PAGE_NAME.INSPECTION_SHEET_PAGE,
    PAGE_NAME.SEARCH_PAGE,
    PAGE_NAME.SEARCH_MACHINES_PAGE,
    PAGE_NAME.SEARCH_INSPECTION_HISTORY_RESULT_PAGE,
    PAGE_NAME.SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE,
    PAGE_NAME.SEARCH_INSPECTION_HISTORY_CORRECTION_PAGE,
    PAGE_NAME.SEARCH_TREATMENT_HISTORY_DETAIL_PAGE,
    PAGE_NAME.MASTER_DASHBOARD_PAGE,
  ],
  user: [
      PAGE_NAME.USER_MASTER_TOP_PAGE,
      PAGE_NAME.USER_MASTER_UPDATE_PAGE,
      PAGE_NAME.USER_MASTER_IMPORT_PAGE,
      PAGE_NAME.USER_MASTER_SEARCH_PAGE,
      PAGE_NAME.USER_MASTER_HISTORY_SEARCH_PAGE,
      PAGE_NAME.USER_MASTER_EXPORT_PAGE
    ],
  master: [
    PAGE_NAME.MACHINE_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.DEPARTMENT_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.POSITION_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.APPROVAL_SETTING_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.INSPECTION_TEMPLATE_MASTER_DASHBOARD_PAGE
  ],
  machine: [
    PAGE_NAME.MACHINE_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.MACHINE_MASTER_UPDATE_PAGE,
    PAGE_NAME.MACHINE_MASTER_HISTORY_SEARCH_PAGE,
    PAGE_NAME.MACHINE_MASTER_IMPORT_PAGE,
    PAGE_NAME.MACHINE_MASTER_EXPORT_PAGE,
    PAGE_NAME.MACHINE_MASTER_GROUP_UPDATE_PAGE,
  ],
  department: [
    PAGE_NAME.DEPARTMENT_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.DEPARTMENT_MASTER_UPDATE_PAGE,
    PAGE_NAME.DEPARTMENT_MASTER_HISTORY_SEARCH_PAGE,
    PAGE_NAME.DEPARTMENT_MASTER_IMPORT_PAGE,
    PAGE_NAME.DEPARTMENT_MASTER_EXPORT_PAGE,
  ],
  position: [
    PAGE_NAME.POSITION_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.POSITION_MASTER_UPDATE_PAGE,
    PAGE_NAME.POSITION_MASTER_HISTORY_SEARCH_PAGE,
    PAGE_NAME.POSITION_MASTER_IMPORT_PAGE,
    PAGE_NAME.POSITION_MASTER_EXPORT_PAGE,
  ],
  approval_setting: [
    PAGE_NAME.APPROVAL_SETTING_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.APPROVAL_SETTING_PAGE,
    PAGE_NAME.APPROVAL_SETTING_MASTER_SEARCH_PAGE,
    PAGE_NAME.APPROVAL_SETTING_MASTER_IMPORT_PAGE,
    PAGE_NAME.APPROVAL_SETTING_MASTER_EXPORT_PAGE,
    PAGE_NAME.APPROVAL_SETTING_DETAIL_PAGE
  ],
  inspection_template: [
    PAGE_NAME.INSPECTION_TEMPLATE_MASTER_DASHBOARD_PAGE,
    PAGE_NAME.TEMPLATE_MANAGEMENT_PAGE,
    PAGE_NAME.INSPECTION_TEMPLATE_MASTER_IMPORT_PAGE,
    PAGE_NAME.INSPECTION_TEMPLATE_MASTER_EXPORT_PAGE,
    PAGE_NAME.INSPECTION_TEMPLATE_MASTER_SEARCH_PAGE,
    PAGE_NAME.INSPECTION_ITEM_EDIT_PAGE,
  ],
}
const COMMON_EXCEPT_CONFIG = {
  user: [
    PAGE_NAME.USER_MASTER_TOP_PAGE,
    PAGE_NAME.USER_MASTER_UPDATE_PAGE,
    PAGE_NAME.USER_MASTER_IMPORT_PAGE,
    PAGE_NAME.USER_MASTER_EXPORT_PAGE,
    PAGE_NAME.USER_MASTER_SEARCH_PAGE,
    PAGE_NAME.USER_MASTER_HISTORY_SEARCH_PAGE
  ]
}

export const REDIRECT_CONFIG = {
  [PAGE_NAME.CHANGE_PASSWORD_PAGE]: { except_transition: COMMON_EXCEPT_CONFIG['user'] },
  [PAGE_NAME.MACHINE_INPUT_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['tenken'], PAGE_NAME.REGISTER_INSPECTION_PAGE]
  },
  [PAGE_NAME.REGISTER_INSPECTION_PAGE]: {
    possible_transition: [PAGE_NAME.MACHINE_INPUT_PAGE, PAGE_NAME.UPDATE_INSPECTION_PAGE],
  },
  [PAGE_NAME.UPDATE_INSPECTION_PAGE]: {
    possible_transition: [
      PAGE_NAME.MACHINE_INPUT_PAGE,
      PAGE_NAME.REGISTER_INSPECTION_PAGE,
      PAGE_NAME.SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE,
    ],
  },
  [PAGE_NAME.JUDGMENT_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['tenken'], PAGE_NAME.INSPECTION_STATUS_PAGE],
  },
  [PAGE_NAME.MASTER_DASHBOARD_PAGE]: {
    possible_transition: [
      ...COMMON_POSSIBLE_CONFIG['tenken'],
      ...COMMON_POSSIBLE_CONFIG['master'],
      ...COMMON_POSSIBLE_CONFIG['machine'],
      ...COMMON_POSSIBLE_CONFIG['department'],
      ...COMMON_POSSIBLE_CONFIG['position'],
      ...COMMON_POSSIBLE_CONFIG['approval_setting'],
      ...COMMON_POSSIBLE_CONFIG['inspection_template']
    ],
  },
  [PAGE_NAME.SEARCH_PAGE]: {
    possible_transition: [
      ...COMMON_POSSIBLE_CONFIG['tenken'],
      PAGE_NAME.SEARCH_MACHINES_PAGE,
      PAGE_NAME.SEARCH_INSPECTION_HISTORY_RESULT_PAGE
    ]
  },
  [PAGE_NAME.SEARCH_MACHINES_PAGE]: {
    possible_transition: [PAGE_NAME.SEARCH_PAGE],
  },
  [PAGE_NAME.SEARCH_INSPECTION_HISTORY_RESULT_PAGE]: {
    possible_transition: [
      PAGE_NAME.SEARCH_PAGE,
      PAGE_NAME.SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE,
      PAGE_NAME.SEARCH_INSPECTION_HISTORY_CORRECTION_PAGE,
      PAGE_NAME.SEARCH_TREATMENT_HISTORY_DETAIL_PAGE,
    ],
  },
  [PAGE_NAME.SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE]: {
    possible_transition: [
      PAGE_NAME.SEARCH_INSPECTION_HISTORY_RESULT_PAGE,
      PAGE_NAME.SEARCH_INSPECTION_HISTORY_CORRECTION_PAGE
    ],
  },
  [PAGE_NAME.SEARCH_INSPECTION_HISTORY_CORRECTION_PAGE]: {
    possible_transition: [PAGE_NAME.REGISTER_INSPECTION_PAGE, PAGE_NAME.SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE],
  },
  [PAGE_NAME.SEARCH_TREATMENT_HISTORY_DETAIL_PAGE]: {
    possible_transition: [PAGE_NAME.SEARCH_INSPECTION_HISTORY_RESULT_PAGE]
  },

  [PAGE_NAME.UNFINISHED_ACTION_LIST_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['tenken'], PAGE_NAME.TREATMENT_PAGE],
  },
  [PAGE_NAME.TREATMENT_PAGE]: {
    possible_transition: [
      PAGE_NAME.UNFINISHED_ACTION_LIST_PAGE,
      PAGE_NAME.INSPECTION_STATUS_PAGE,
      PAGE_NAME.INSPECTION_SHEET_PAGE
    ],
  },
  [PAGE_NAME.MY_PAGE_PAGE]: { except_transition: COMMON_EXCEPT_CONFIG['user'] },
  [PAGE_NAME.SETTING_PAGE]: { except_transition: COMMON_EXCEPT_CONFIG['user'] },
  [PAGE_NAME.TEMPLATE_MANAGEMENT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['inspection_template'] },
  [PAGE_NAME.INSPECTION_ITEM_EDIT_PAGE]: { possible_transition: [PAGE_NAME.TEMPLATE_MANAGEMENT_PAGE] },

  [PAGE_NAME.MACHINE_MASTER_DASHBOARD_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['machine'], PAGE_NAME.MASTER_DASHBOARD_PAGE],
  },
  [PAGE_NAME.MACHINE_MASTER_UPDATE_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['machine'] },
  [PAGE_NAME.MACHINE_MASTER_IMPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['machine'] },
  [PAGE_NAME.MACHINE_MASTER_EXPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['machine'] },
  [PAGE_NAME.MACHINE_MASTER_HISTORY_SEARCH_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['machine'] },
  [PAGE_NAME.MACHINE_MASTER_GROUP_UPDATE_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['machine'] },

  [PAGE_NAME.POSITION_MASTER_DASHBOARD_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['position'], PAGE_NAME.MASTER_DASHBOARD_PAGE],
  },
  [PAGE_NAME.POSITION_MASTER_UPDATE_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['position'] },
  [PAGE_NAME.POSITION_MASTER_HISTORY_SEARCH_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['position'] },
  [PAGE_NAME.POSITION_MASTER_IMPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['position'] },
  [PAGE_NAME.POSITION_MASTER_EXPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['position'] },

  [PAGE_NAME.DEPARTMENT_MASTER_DASHBOARD_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['department'], PAGE_NAME.MASTER_DASHBOARD_PAGE],
  },
  [PAGE_NAME.DEPARTMENT_MASTER_UPDATE_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['department'] },
  [PAGE_NAME.DEPARTMENT_MASTER_HISTORY_SEARCH_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['department'] },
  [PAGE_NAME.DEPARTMENT_MASTER_IMPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['department'] },
  [PAGE_NAME.DEPARTMENT_MASTER_EXPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['department'] },

  [PAGE_NAME.INSPECTION_STATUS_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['tenken'] },
  [PAGE_NAME.INSPECTION_SHEET_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['tenken'], PAGE_NAME.INSPECTION_STATUS_PAGE],
  },

  [PAGE_NAME.INSPECTION_TEMPLATE_MASTER_DASHBOARD_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['inspection_template'], PAGE_NAME.MASTER_DASHBOARD_PAGE],
  },
  [PAGE_NAME.INSPECTION_TEMPLATE_MASTER_SEARCH_PAGE]: {
    possible_transition: COMMON_POSSIBLE_CONFIG['inspection_template'],
  },
  [PAGE_NAME.INSPECTION_TEMPLATE_MASTER_IMPORT_PAGE]: {
    possible_transition: COMMON_POSSIBLE_CONFIG['inspection_template'],
  },
  [PAGE_NAME.INSPECTION_TEMPLATE_MASTER_EXPORT_PAGE]: {
    possible_transition: COMMON_POSSIBLE_CONFIG['inspection_template'],
  },

  [PAGE_NAME.APPROVAL_SETTING_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['approval_setting'], PAGE_NAME.APPROVAL_SETTING_DETAIL_PAGE],
  },
  [PAGE_NAME.APPROVAL_SETTING_DETAIL_PAGE]: { possible_transition: [PAGE_NAME.APPROVAL_SETTING_PAGE]},
  [PAGE_NAME.APPROVAL_SETTING_MASTER_DASHBOARD_PAGE]: {
    possible_transition: [...COMMON_POSSIBLE_CONFIG['approval_setting'], PAGE_NAME.MASTER_DASHBOARD_PAGE]
  },
  [PAGE_NAME.APPROVAL_SETTING_MASTER_SEARCH_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['approval_setting'] },
  [PAGE_NAME.APPROVAL_SETTING_MASTER_IMPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['approval_setting'] },
  [PAGE_NAME.APPROVAL_SETTING_MASTER_EXPORT_PAGE]: { possible_transition: COMMON_POSSIBLE_CONFIG['approval_setting'] },

  [PAGE_NAME.USER_MASTER_EXPORT_PAGE]: {possible_transition: COMMON_POSSIBLE_CONFIG['user']},
  [PAGE_NAME.USER_MASTER_UPDATE_PAGE]: {possible_transition: COMMON_POSSIBLE_CONFIG['user']},
  [PAGE_NAME.USER_MASTER_IMPORT_PAGE]: {possible_transition: COMMON_POSSIBLE_CONFIG['user']},
  [PAGE_NAME.USER_MASTER_HISTORY_SEARCH_PAGE]: {possible_transition: COMMON_POSSIBLE_CONFIG['user']},
  [PAGE_NAME.USER_MASTER_SEARCH_PAGE]: {possible_transition: COMMON_POSSIBLE_CONFIG['user']},
};
